import React from 'react';
import { CheckCircleIcon, CheckCircleSolidIcon } from '@fiverr-private/visuals';
import { Tooltip } from '@fiverr-private/tooltip';
import { AvailabilityStatus } from '../../constants/enums';
import { appTranslate } from '../../i18n';

interface ServiceAvailabilityIndicatorProps {
    status: AvailabilityStatus;
}

export const ServiceAvailabilityIndicator = ({ status }: ServiceAvailabilityIndicatorProps) => {
    switch (status) {
        case AvailabilityStatus.Yes: {
            return <CheckCircleSolidIcon color="grey_1200" />;
        }
        case AvailabilityStatus.Partial: {
            return (
                <Tooltip
                    content={appTranslate('compare_packages.tooltips.availability_status_tooltip')}
                    anchorProps={{
                        display: 'flex',
                    }}
                    offset={8}
                >
                    <CheckCircleIcon color="grey_1200" />
                </Tooltip>
            );
        }
        case AvailabilityStatus.No: {
            return null;
        }
        default: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const _exhaustiveCheck: never = status;
            return null;
        }
    }
};
